import React, { useEffect, useState } from "react";
import {
  ACTIONARROW_ICON,
  EDIT_ICON,
  RIGHTARROW_ICON,
} from "../../../utills/image-constant";
import AdminDataTable from "../../components/common/AdminDataTable";
import TableHeading from "../../components/common/TableHeading";
import SearchAndAddItem from "../../components/common/TableData";
import { ROUTES } from "../../routes/url-constant";
import { useNavigate } from "react-router-dom";
import { getAdminBlock, getallAdmin, getallAdminRole } from "../../../services/api-services";
import { toastEmitter } from "../../../utills/utilities";
import { API_RESPONSE } from "../../../utills/app-constant";
import { useSelector } from "react-redux";
import AccessPermissionpage from "./AccessPermissionpage";

const EmployeeTable = () => {
  const [pending, setPending] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [sortColumn, setSortColumn] = useState("id");
  const [sortDirection, setSortDirection] = useState("desc");
  const [permissionAccess, setPermissionAccess] = useState();
  const { value } = useSelector((state) => state?.adminRole);
  const [totalElement, settotalElement] = useState();
  const [allRoleList, setAllRoleList] = useState([]);
  const [selectRole, setselectRole] = useState(localStorage.getItem("RoleValue") || "");
  let localRoleId = localStorage.getItem("RoleValue")
  useEffect(() => {
    const RoleAccessFilterData =
      value && value?.filter((v) => v.moduleName === "Team Management");
    setPermissionAccess(RoleAccessFilterData?.[0]);
  }, [value]);

  const payload = {
    pageIndex: page,
    pageSize: pageSize,
    searchText,
    direction: sortDirection,
    filterByFieldName: sortColumn,
    roleId: localRoleId ? localRoleId : selectRole
  }

  const getallRoleEmp = async () => {
    setPending(true);

    try {
      const response = await getallAdmin(payload);
      if (response?.data?.responseCode === 404) {
        setRowData([]);
      } else if (response?.data?.responseCode === 200) {
        setRowData(response?.data?.responseBody?.adminResponsePayloadList);
        settotalElement(response?.data?.responseBody?.totalElement);
      } else {
        toastEmitter("error", response?.data?.message);
        setPending(false);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
      setPending(false);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    getallRoleEmp();
  }, [page, pageSize, searchText, sortColumn, sortDirection, selectRole, localRoleId]); // Trigger API when payload updates

  const getallRole = async () => {
    let adminPayload = {
      pageIndex: 0,
      pageSize: 10000000,
      searchText: "",
      direction: "desc",
      filterByFieldName: "id",
    }
    setPending(true);
    try {
      const response = await getallAdminRole(adminPayload);
      if (response?.data?.responseCode === 404) {
        // setRowData([]);
      } else if (response?.data?.responseCode === 200) {
        const roleList =
          response?.data?.responseBody?.roleList.map(
            (data) => ({
              value: data?.id,
              label: data?.roleName,
              Status: data?.status,
            })
          );
        setAllRoleList(roleList);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    getallRole();
  }, []);

  const hadleselectedRole = (e) => {
    if (e.target.value == "") {
      setselectRole(e.target.value)
      localStorage.removeItem("RoleValue")
    } else {
      setselectRole(e.target.value)
      localStorage.setItem("RoleValue", e.target.value)
    }
  }
  const tableCustomStyles = {
    headRow: {
      style: {
        color: "#1B2128",
        fontSize: "14px",
      },
    },
    rows: {
      style: {
        color: "#1B2128",
        fontSize: "14px",
      },
    },
  };

  const handleStatusToggle = async (row) => {
    const newStatus = row?.status === 1 ? 0 : 1; // Toggle the status

    // Optimistically update the status in the local rowData
    const updatedRowData = rowData.map((item) =>
      item.id === row.id ? { ...item, status: newStatus } : item
    );
    setRowData(updatedRowData); // Update local state with the new status
    try {
      let response = await getAdminBlock(row.id, newStatus);

      if (response?.data?.responseCode === 200) {
        toastEmitter("success", response?.data?.message);
      } else {
        // If the API fails, revert the status in local state
        const revertRowData = rowData.map((item) =>
          item.id === row.id ? { ...item, status: row?.status } : item
        );
        setRowData(revertRowData);
        console.error("Failed to update model status");
      }
    } catch (error) {
      // If there's an error, revert the status in local state
      const revertRowData = rowData.map((item) =>
        item.id === row.id ? { ...item, status: row?.status } : item
      );
      setRowData(revertRowData);
      console.error("Error during status change:", error);
    }
  };


  const tblColumns = [
    {
      code: "Action",
      name: "Action",
      width: "150px",
      sortable: false,
      cell: (row) => (
        <div>
          <button className="border-0 bg-white">
            {permissionAccess?.updateAction === 1 && (
              <img
                src={EDIT_ICON}
                alt="Edit"
                className="editicon"
                onClick={() =>
                  navigate(ROUTES?.ADDEMPLOYEE, {
                    state: { pageType: "Edit", Data: row },
                  })
                }
              />

            )}
            <span>
              <button className="border-0 bg-white" onClick={() => navigate(ROUTES.ADDEMPLOYEE, { state: { pageType: "view", Data: row } })}>
                <img src={ACTIONARROW_ICON} alt="View" className="editicon ms-2" />
              </button>
            </span>
          </button>
        </div>
      ),
    },
    {
      code: "name",
      name: "Employee Name",
      width: "230px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.name}</div>
      ),
    },
    {
      code: "email",
      name: "Email",
      width: "300px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.email}</div>
      ),
    },
    {
      code: "mobileNumber",
      name: "Mobile Number",
      width: "170px",
      sortable: false,
      selector: (row) => `${row?.mobileNumber ? row?.mobileNumber : "-"}`,
    },
    {
      code: "roleName",
      name: "Role Name",
      width: "160px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.roleResponsePayload?.roleName}</div>
      ),
    },
    {
      code: "status",
      name: "Status",
      omit: false,
      sortable: true,
      selector: (row) => (
        <div className="form-switch-btn">
          <label className="switch">
            <input
              disabled={permissionAccess?.moduleAction === 0}
              type="checkbox"
              id="togBtn"
              checked={row.status === 1} // Checked if active
              onChange={() => handleStatusToggle(row)}
            />
            <div className="slider round">
              <span className="on">Active</span>
              <span className="off">Inactive</span>
            </div>
          </label>
        </div>
      ),
    },

  ];

  const handleModelSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const navigate = useNavigate();

  const addButtonClick = () => {
    navigate(ROUTES.ADDEMPLOYEE);
  };

  const handleClearFilter = () => {
    setselectRole("")
    localStorage.removeItem("RoleValue")
  }

  return (
    <>
      {permissionAccess?.addAction == 0 &&
        permissionAccess?.updateAction == 0 &&
        permissionAccess?.viewAction === 0 ? (
        <>
          <AccessPermissionpage />
        </>
      ) : (
        <>
          <div className="modal_datatable">
            <TableHeading secondData="Team Employees" icon={RIGHTARROW_ICON} firstData="Team Management" />
            <div className="container-fluid">
              <div className="caspera_admin_datatable mb-3">

                <SearchAndAddItem
                  // title="Team Employees"
                  searchValue={searchText}
                  onSearchChange={handleModelSearchChange}
                  addButtonClick={addButtonClick}
                  data="Employee"
                  permissionAccessbtn={permissionAccess?.addAction}
                  labelName="Select Role"
                  lableclassName="addInput-label"
                  name="selectRole"
                  options={allRoleList}
                  className="form-control addInputText-lable"
                  handleSelect={hadleselectedRole}
                  value={localRoleId ? localRoleId : selectRole}
                  showDropdown={true}
                  clearbtn={true}
                  handleClear={handleClearFilter}
                />

                <AdminDataTable
                  _tblColumns={tblColumns}
                  _rowData={rowData}
                  tableCustomStyles={tableCustomStyles}
                  _totalRows={totalElement}
                  pending={pending}
                  setPending={setPending}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  setPage={setPage}
                  totalElement={totalElement}
                  setSortColumn={setSortColumn}
                  setSortDirection={setSortDirection}
                />

              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default EmployeeTable;
